/**
 * Return an object array of url parameters
 */
const useParams = () => {
  let queryString = window.location.href;

  queryString = queryString.trim().split('?');

  if (queryString.length > 1) {
    // We've got a query string
    queryString = queryString[1];

    // We've got & too
    queryString = queryString.split('&');

    let obj = {};

    queryString.forEach((item) => {
      const split = item.split('=');

      if (split.length > 1) {
        let [key, value] = split;

        value = value.includes('#') ? value.split('#')[0] : value;

        obj = { ...obj, [key]: value };
      }
    });

    return Object.keys(obj).length > 0 ? obj : null;
  }
};

export default useParams;
